
import { Component, Vue } from "vue-property-decorator";
import AuthHelper from "@/services/AuthHelper";
import { Action } from "vuex-class";

@Component
export default class Logout extends Vue {
  @Action("lock") lock!: () => void;
  @Action("logout") logout!: () => void;

  render() {
    return null;
  }

  async created() {
    this.lock();
    this.logout();

    const authHelper = new AuthHelper();
    const uri = authHelper.getLogoutUri();

    window.location.href = uri;
  }
}
